// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"288":"9078e2a4","489":"2051b1b5","736":"9abd808f"}[chunkId] + ".css";
};